import React from 'react';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import { FormattedMessage } from 'react-intl';
import { CSVLink } from 'react-csv';

import Table from '../../components/table';
import SearchBar from '../../components/searchBar';
import messages from '../../text/messages';
import { formatMoney } from '../../utilities/string';
import { getPayrollDetails } from '../../reducers/payrolls';
import { exportPayroll, exportExecupayPayroll } from './exports/payroll';
import { dateToFloatingString } from '../../utilities/dateTime';
import Tooltip from 'rc-tooltip';

class PayrollsList extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            searchString: '',
            csvData: [],
            fileName: ''
        };

        this.getColumnDefinition = this.getColumnDefinition.bind(this);
        this.getCSV = this.getCSV.bind(this);
    }

    filterResults() {
        const { payrolls } = this.props;
        const { searchString } = this.state;

        if (!searchString.trim()) {
            return payrolls;
        }

        let filter = searchString.toLowerCase();
        return payrolls.filter(({ name }) => name.toLowerCase().includes(filter) || name.toLowerCase().includes(filter));
    }

    getCSV(payroll, execupay) {
        const { getPayrollDetails } = this.props;
        let queryParams;
        if (execupay) {
            queryParams = {
                model: 'execupay'
            };
        }

        getPayrollDetails(payroll.id, queryParams, response => {
            const getCsvData = execupay ? exportExecupayPayroll : exportPayroll;
            const { csvData, fileName } = getCsvData(payroll, response);
            this.setState({ csvData, fileName }, () => this.csvLink.link.click());
        });
    }

    getColumnDefinition() {
        const timeSort = (a, b) => new Date(a.date).getTime() - new Date(b.date).getTime();

        let columns = [
            {
                label: <FormattedMessage {...messages.payrollDate} />,
                valueMap: payroll => <div className="full-height-cell ellipsis">{dateToFloatingString(payroll.transfer_date)}</div>,
                size: 'col-xs-9 col-sm-4',
                sort: timeSort
            },
            {
                label: <FormattedMessage id={'payrollNo'} defaultMessage={`Payroll #`} />,
                valueMap: payroll => <div className="full-height-cell ellipsis">{payroll.name}</div>,
                size: 'col-xs-2 hidden-xs',
                sort: (a, b) => a.name.localeCompare(b.name)
            },
            {
                label: <FormattedMessage {...messages.currency} />,
                valueMap: payroll => <div className="full-height-cell ellipsis">{payroll.currency}</div>,
                size: 'col-xs-2 hidden-xs',
                sort: (a, b) => a.currency.localeCompare(b.currency)
            },
            {
                label: <FormattedMessage {...messages.amount} />,
                valueMap: payroll => <div className="full-height-cell ellipsis">{formatMoney(payroll.amount, payroll.currency)}</div>,
                size: 'col-xs-2 hidden-xs',
                sort: (a, b) => a.amount - b.amount
            },
            {
                label: '',
                valueMap: payroll => (
                    <div className="full-height-cell text-center">
                        <Tooltip placement="top" trigger={'hover'} overlay={<FormattedMessage id={'exportPayrollCsv'} defaultMessage={`Export (CSV)`} />}>
                            <a onClick={() => this.getCSV(payroll)}>
                                <i className="material-icons download">publish</i>
                            </a>
                        </Tooltip>
                        <Tooltip
                            placement="top"
                            trigger={'hover'}
                            overlay={<FormattedMessage id={'exportExecupayPayrollCsv'} defaultMessage={`Export (Execupay)`} />}
                        >
                            <a onClick={() => this.getCSV(payroll, true)}>
                                <i className="material-icons download">publish</i>
                            </a>
                        </Tooltip>
                    </div>
                ),
                size: 'col-xs-3 col-sm-2 payrolls-csv-buttons',
                justify: 'right'
            }
        ];

        return columns;
    }

    render() {
        const filterResults = this.filterResults();
        return (
            <div className="payrolls-list">
                <div className="row">
                    <div className="col-sm-6 col-xs-12">
                        <SearchBar onSubmit={payroll => this.setState({ ...this.state, searchString: payroll.value })} />
                    </div>
                </div>
                <CSVLink ref={el => (this.csvLink = el)} data={this.state.csvData} filename={this.state.fileName} />
                <div className="col-xs-12">
                    <Table data={filterResults || []} columns={this.getColumnDefinition()} defaultSortColumn={0} />
                </div>
            </div>
        );
    }
}

const mapDispatchToProps = dispatch =>
    bindActionCreators(
        {
            getPayrollDetails
        },
        dispatch
    );

export default connect(null, mapDispatchToProps)(PayrollsList);



// WEBPACK FOOTER //
// ./src/pages/payrolls/payrollsList.jsx